// Impersonation state that has to survive a page reload, kept apart from the service that
// talks to the API so `api-service` can read it without importing back into itself.

export const IMPERSONATION_STORAGE_KEY = 'impersonation';
export const IMPERSONATION_SESSION_HEADER = 'X-Impersonate-Session';

export interface StoredImpersonation {
  sessionId: number;
  // Cached only so the banner has something to show before /profile/ comes back.
  targetName: string;
  realName: string;
}

export const getImpersonation = (): StoredImpersonation | null => {
  try {
    const raw = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed?.sessionId === 'number' ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const setImpersonation = (state: StoredImpersonation): void => {
  localStorage.setItem(IMPERSONATION_STORAGE_KEY, JSON.stringify(state));
};

export const clearImpersonation = (): void => {
  localStorage.removeItem(IMPERSONATION_STORAGE_KEY);
};
